import axios from 'axios'
import router from '../router/index'
import store from '@/store/index'
import {Toast} from 'vant'
import { dc, netUrl } from '../../configapi'
const service = axios.create({
  baseURL: dc,//正式
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
})

//token设置
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token = window.localStorage.token
  // //console.log('token',token)
  if (token) {
    config.headers['X-AUTH-TOKEN'] = token
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
service.interceptors.response.use(function (response) {
  store.commit('setConnect', true)
  store.commit('updateShowPayTip', false);
  // //console.log('response.headers,',response.headers)
  if (response.headers['X-AUTH-TOKEN']) {
    localStorage.setItem('token', response.headers['X-AUTH-TOKEN'])
  }
  if (response.data.code == 401) {
    // console.log(response.data);
    router.replace({
      path: '/login',
      query: {
        redirect: router.currentRoute.fullPath//登录之后跳转到对应页面
      }
    });
    store.commit('deleteshopLevel');
    store.commit('updateIsShowSidebar', false);
    localStorage.removeItem('token')
    clearInterval();
  }
  if (response.data.code == 1001) {
    store.commit('updateShowPayTip', true);
    store.commit('updatePayTipMsg', response.data.msg || '');
  }
  return response;
}, function (error) {
  if (!axios.isCancel(error)) {
    store.commit('setConnect', false)
    Toast(error.message || '网络连接失败！')
  }

  return Promise.reject(error);
});

// service.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
// service.defaults.headers.common['X-AUTH-TOKEN'] = '';
export default function request({ url, data = {}, method = 'get', cancelToken }) {
  return new Promise((resolve, reject) => {
    const options = {
      url,
      method,
      cancelToken,
    }
    // //console.log(url, method)
    if (method.toLowerCase() === 'get') {
      options.params = data
    }
    else {
      options.data = data
    }
    service(options).then(res => {
      // //console.log('返回数据', res)
      resolve(res.data)
    })
      .catch(error => {
        reject()
        console.error(error)
      })
  })
}




// WEBPACK FOOTER //
// ./src/request/http.js